

export const coinsToMoney = (coins) => {
  return coins / 100;
};
